import { useState, useEffect, useRef, useCallback, useMemo } from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import { FilterChangedEvent } from "ag-grid-community";
import "ag-grid-enterprise";
import { useTheme } from "@mui/material/styles";
import _, { isString } from "lodash";
import axios from "axios";
import moment from "moment";
import {
  validateQuantity,
  validateRate,
  validateTermDate,
} from "../../common/tradeValidations";
import {
  constants,
  EndPoint,
  LocateStatus,
  socketMsgType,
} from "../../common/constants";
import {
  locateClientColdDefs,
  locateColdDefs,
} from "../../common/locateColumnDefs";
import {
  envs,
  getEnv,
  serviceAPIMapping,
} from "../../config/service-api-mapping";
import { AgGridReact } from "ag-grid-react";
import SpinnerFullScreen from "../SpinnerFullScreen";
import SockJS from "sockjs-client";
import { BASE_URI_SOCKET } from "../../config/service-api-mapping";
import { Stomp } from "@stomp/stompjs";
import { Icon } from "@iconify/react";
// import Queue from "yocto-queue";

interface AgGridProps {
  title?: string;
  onClickHan?: any;
  onClickSelectData?: any;
  onCellChange?: any;
  seTtotalSelectedRows?: any;
  getBtnRef?: any;
  getGridApi?: any;
  // doesExternalFilterPass?: any;
  // isExternalFilterPresent?: any;
  isDeselectAll?: boolean;
  getContextMenuItems?: any;
  globalSearch?: any;
  isSingleRowInserted?: boolean;
  defaultFilter?: any;
  isLocatesRefreshed: boolean;
  newRows?: any;
  isAdmin: boolean;
  onRowSelect: any;
  date?: any;
  setSelectedRows: any;
  sourceFilter?: any;
  statusFilter?: any;
  // isExcludeApproved?: boolean;
  globalClient?: string;
  enableSocketUpdates?: boolean;
  currentInterval?: number;
  isResetFilters?: boolean;
  showTotalRow: boolean;
  clientList?: any;
  currentKPITicker?: any;
  onIsRefreshTickerKPI?: any;
}

const LocatesGrid = ({
  title,
  getGridApi,
  // doesExternalFilterPass,
  // isExternalFilterPresent,
  isDeselectAll,
  getContextMenuItems,
  globalSearch,
  defaultFilter,
  isLocatesRefreshed,
  getBtnRef,
  newRows,
  isAdmin,
  onRowSelect,
  date,
  setSelectedRows,
  sourceFilter,
  statusFilter,
  // isExcludeApproved,
  globalClient,
  enableSocketUpdates,
  showTotalRow,
  currentInterval,
  isResetFilters,
  clientList,
  currentKPITicker,
  onIsRefreshTickerKPI,
}: AgGridProps) => {
  const gridRef = useRef<any>(null);
  const theme = useTheme();
  // const channel = new BroadcastChannel(Key.broadcastChannel)
  // const [locateRows, setLocateRows] = useState<any>([]);
  const [initialLocates, setInitialLocates] = useState<any>([]);
  const [showScreenLoader, setShowScreenLoader] = useState<boolean>(false);
  const [locateBkpStr, setLocateBkpStr] = useState<any>("");
  const [insertLocateRows, setInsertLocateRows] = useState<any>([]);
  const [currentRowId, setCurrentRowId] = useState(null);
  const activeClientShortName = window.localStorage.getItem(
    "activeClientShortName"
  );
  const rowDataRef = useRef<any>([]);
  const [currentSelectedTicker, setCurrentSelectedTicker] =
    useState(currentKPITicker);
  const loginUser = window.localStorage.getItem("username");
  const externalFilterRef = useRef("all");

  const isExternalFilterPresent = () => {
    return externalFilterRef.current !== "all";
  };

  const doesExternalFilterPass = (node: any) => {
    if (externalFilterRef.current === "all") return true;
    return node.data.status === externalFilterRef.current;
  };

  const ActionRenderer = (props: any) => {
    const onLocateUpdate = (status: string, action?: string) => {
      const request = {
        locate_id: props?.node?.data?.locate_id,
        rebate: props?.node?.data?.rebate,
        fee: props?.node?.data?.fee,
        centpershare: props?.node?.data?.centpershare,
        request_quantity: props?.node?.data?.request_quantity,
        username: props?.node?.data?.username,
        action_status:
          status === LocateStatus.Approved
            ? props?.node?.data?.approved_quantity <
              props?.node?.data?.request_quantity
              ? LocateStatus.Partial
              : status
            : status,
        comments: props?.node?.data?.comments,
        qty_appr: props?.node?.data?.approved_quantity,
      };

      if (action === "save") {
        updateLocateApproved(request);
      } else {
        if (
          request &&
          validateQuantity(request?.request_quantity) &&
          request?.action_status &&
          request?.locate_id &&
          ((request?.rebate && validateRate(request?.rebate)) ||
            request?.centpershare) &&
          !props?.node?.data?.hasError
        ) {
          updateLocateApproved(request);
        }
      }
    };

    const onApproveClick = () => {
      if (
        (props?.node?.data?.status === LocateStatus.Rejected ||
          props?.node?.data?.status === LocateStatus.Pending) &&
        !props?.node?.data?.hasError &&
        props?.node?.data?.isRowChanged
      ) {
        onLocateUpdate(LocateStatus.Topup);
      }
    };

    const onRejectClick = () => {
      if (
        props?.node?.data?.status === LocateStatus.Pending &&
        !props?.node?.data?.hasError
      ) {
        onLocateUpdate(LocateStatus.Rejected);
      }
    };

    const onSaveClick = () => {
      if (
        (props?.node?.data?.status === LocateStatus.Topup ||
          props?.node?.data?.status === LocateStatus.New ||
          props?.node?.data?.status === LocateStatus.Approved) &&
        !props?.node?.data?.hasError &&
        props?.node?.data?.isRowChanged
      ) {
        onLocateUpdate(props?.node?.data?.status, "save");
      }
    };

    if (!props?.node?.data?.isTotalRow) {
      return (
        <>
          <div className="d-flex flex-row justify-content-between align-items-center">
            <span
              aria-disabled={
                (props?.node?.data?.status !== LocateStatus.Rejected ||
                  props?.node?.data?.status !== LocateStatus.Pending) &&
                props?.node?.data?.hasError &&
                props?.node?.data?.isRowChanged
              }
              title="Approve"
            >
              <Icon
                icon={"charm:tick"}
                fontSize={"1rem"}
                onClick={() => {
                  onApproveClick();
                }}
                className={
                  (props?.node?.data?.status === LocateStatus.Rejected ||
                    props?.node?.data?.status === LocateStatus.Pending) &&
                  !props?.node?.data?.hasError &&
                  props?.node?.data?.isRowChanged
                    ? "locate-grid-icon-add"
                    : "locate-grid-icon-disable"
                }
              ></Icon>
            </span>
            <span
              title="Reject"
              aria-disabled={
                props?.node?.data?.status !== LocateStatus.Pending &&
                !props?.node?.data?.hasError &&
                props?.node?.data?.isRowChanged
              }
            >
              <Icon
                onClick={() => onRejectClick()}
                icon={"fluent-emoji-high-contrast:cross-mark"}
                fontSize={"0.7rem"}
                className={
                  props?.node?.data?.status === LocateStatus.Pending
                    ? "ms-2 locate-grid-icon-reject"
                    : "ms-2 locate-grid-icon-disable"
                }
              ></Icon>
            </span>

            <span
              aria-disabled={
                (props?.node?.data?.status !== LocateStatus.Approved ||
                  props?.node?.data?.status !== LocateStatus.Topup) &&
                (props?.node?.data?.hasError ||
                  !props?.node?.data?.isRowChanged)
              }
              title="Save"
            >
              <Icon
                icon={"lucide:save"}
                fontSize={"1rem"}
                onClick={() => onSaveClick()}
                className={
                  (props?.node?.data?.status === LocateStatus.Topup ||
                    props?.node?.data?.status === LocateStatus.New ||
                    props?.node?.data?.status === LocateStatus.Approved) &&
                  !props?.node?.data?.hasError &&
                  props?.node?.data?.isRowChanged
                    ? "ms-2 icon-cursor-pointer"
                    : "ms-2 locate-grid-icon-disable"
                }
              ></Icon>
            </span>
          </div>
        </>
      );
    }
  };

  const coldDefs = () => {
    let columns: any[] = [];
    if (isAdmin) {
      columns = locateColdDefs?.map((colDef: any) => {
        if (colDef?.colId === "action") {
          return {
            ...colDef,
            enableCellChangeFlash: false,
            cellRenderer: ActionRenderer,
          };
        } else {
          return colDef;
        }
      });
    } else {
      columns = locateClientColdDefs;
    }

    return columns;
  };
  const [columnDefs] = useState<any>(coldDefs);
  const [gridTheme, setGridTheme] = useState<string>(
    theme.palette.mode === "dark" ? " ag-theme-balham-dark" : " ag-theme-balham"
  );

  const socketConsolidate = new SockJS(`${BASE_URI_SOCKET()}`);
  const socketConsolidateClient = Stomp.over(function () {
    return socketConsolidate;
  });
  // const queue = new Queue();

  useEffect(() => {
    let returnInterval: any;

    if (enableSocketUpdates && !socketConsolidateClient?.connected) {
      socketConsolidateClient.connect(
        {},
        function (frame: any) {
          socketConsolidateClient.subscribe(
            "/topic/consolidated_message",
            async function asy(result: any) {
              let resultJson = JSON.parse(result?.body);
              if (isAdmin && getEnv() !== envs.PROD) {
                console.log(
                  `Data received from /topic/consolidated_message at ${moment()?.toDate()} - `,
                  resultJson
                );
              }

              await onSocketMsgReceive(resultJson?.socketMssgmap);
            }
          );
        },
        {},
        () => {}
      );
    } else {
      if (currentInterval && currentInterval > 0) {
        returnInterval = setInterval(() => {
          getLocates();
        }, currentInterval);
        return () => clearInterval(returnInterval);
      }
      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
    }

    return () => {
      clearInterval(returnInterval);

      if (socketConsolidateClient?.connected) {
        socketConsolidateClient?.unsubscribe("/topic/consolidated_message");
        socketConsolidateClient?.disconnect();
      }
      // if (queue) {
      //   queue?.clear();
      // }
    };
  }, [enableSocketUpdates, currentInterval]);

  const onSocketMsgReceive = async (msg: any) => {
    // const orders = _.get(msg, socketMsgType.ORDER);
    // const updateOrders = _.get(msg, socketMsgType.LOCATE_ORDER_UPDATE);

    // const formatRow = (row: any) => {

    //   return {
    //     ...row,
    //     centpershare: _.isNaN(row?.centpershare)
    //       ? ""
    //       : row?.centpershare?.toFixed(4),
    //     centpershare_appr: _.isNaN(row?.centpershare_appr)
    //       ? ""
    //       : row?.centpershare_appr?.toFixed(4),
    //     rebate: _.isNaN(row?.rebate) ? "" : (+row?.rebate)?.toFixed(4),
    //     rate_appr: _.isNaN(row?.rate_appr) ? "" : (+row?.rate_appr)?.toFixed(4),
    //      isCommentsChanged:false,
    //     updatetime : moment(row?.updatetime)?.format('HH:mm:ss'),
    //     comments: row?.comments,
    //     status:row?.status
    //   };
    // };

    // const currentMap = new Map(
    //   rowDataRef.current.map((row: any) => [row.locate_id, row])
    // );
    // let updatedRows: any[] = [];
    // let insertedRows: any[] = [];
    // // let updatedRowNodes: any[] = [];
    // const pendingIds = new Set<string>();
    // const processRows = (rows: any[], isUpdate = false) => {

    //   setCurrentSelectedTicker((previousData: any)=>{
    //       const ticList = [...rows]?.filter((s: any)=>s?.ticker === previousData)
    //       onIsRefreshTickerKPI?.(ticList?.length>0)
    //   })

    //   rows.forEach((row: any) => {
    //     const formatted = formatRow(row);
    //     if (currentMap.has(formatted.locate_id)) {
    //       currentMap.set(formatted.locate_id, formatted);
    //       console.log('formatted', formatted)
    //       updatedRows.push(formatted);
    //       // const rowNode = gridRef?.current?.api?.getRowNode(formatted?.locate_id);
    //       // if (rowNode) updatedRowNodes.push(rowNode);
    //     } else if (!isUpdate && !pendingIds.has(formatted.locate_id)) {
    //       currentMap.set(formatted.locate_id, formatted);
    //       insertedRows.push(formatted);
    //       pendingIds.add(formatted.locate_id);
    //     }
    //   });
    // };

    // if (_.isArray(updateOrders) && updateOrders.length > 0) {
    //   const socketRows = updateOrders
    //     .map((item: any) => item?.messageJson)
    //     .filter((x: any) =>
    //       (!isAdmin ? x.cpty === activeClientShortName : true)
    //     );
    //   if (socketRows.length > 0) {
    //     processRows(socketRows, true);

    //   }
    // }

    // if (_.isArray(orders) && orders.length > 0) {
    //   const socketRows = orders.map((item: any) => item?.messageJson);
    //   const locates = socketRows.filter((order: any) =>
    //     order?.assetType === "Locate" && !isAdmin && order?.username !== loginUser
    //       ? order.cpty === activeClientShortName
    //       : true
    //   );
    //   if (locates.length > 0) {
    //     processRows(locates);
    //   }
    // }

    // const newRowData = Array.from(currentMap.values());

    // if (gridRef?.current?.api) {
    //   const transaction = {
    //     update: [...updatedRows],
    //     add: [...insertedRows],
    //     addIndex: 0
    //   };
    //  await gridRef.current.api.applyTransactionAsync(transaction, () => {
    //    insertedRows.forEach(r => pendingIds.delete(r.locate_id));
    //   //  const refreshParams: any = {
    //   //       force: true,
    //   //       suppressFlash: true,
    //   //       rowNodes: [...updatedRowNodes]
    //   //     };
    //   //   gridRef?.current!.api?.refreshCells(refreshParams);

    //  });

    // }
    // setInitialLocates([...newRowData]);

    const orders = _.get(msg, socketMsgType.ORDER);
    const updateOrders = _.get(msg, socketMsgType.LOCATE_ORDER_UPDATE);

    if((orders && orders?.length>0) || (updateOrders && updateOrders?.length>0)){
      const formatRow = (row: any) => ({
      ...row,
      centpershare: _.isNaN(row?.centpershare)
        ? ""
        : row?.centpershare?.toFixed(4),
      centpershare_appr: _.isNaN(row?.centpershare_appr)
        ? ""
        : row?.centpershare_appr?.toFixed(4),
      rebate: _.isNaN(row?.rebate) ? "" : (+row?.rebate)?.toFixed(4),
      rate_appr: _.isNaN(row?.rate_appr) ? "" : (+row?.rate_appr)?.toFixed(4),
      updatetime: moment(row?.updatetime)?.format("HH:mm:ss"),
      isCommentsChanged: false,
    });

    setInitialLocates((prev: any) => {
      const map = new Map(prev.map((row: any) => [row.locate_id, row]));
      let updatedRows: any[] = [];
      let insertedRows: any[] = [];

      const process = (rows: any[], isUpdate = false) => {
        rows.forEach((r) => {
          const f = formatRow(r);
          if (map.has(f.locate_id)) {
            map.set(f.locate_id, f);
            updatedRows.push(f);
          } else if (!isUpdate) {
            map.set(f.locate_id, f);
            insertedRows.push(f);
          }
        });
      };

      if (_.isArray(updateOrders)) {
        const socketRows = updateOrders?.map((item: any) => item?.messageJson)?.filter((x: any) =>
          (x?.username !== loginUser && !isAdmin ? x.cpty === activeClientShortName : true)
        );
        process(socketRows,true);
      }
      if (_.isArray(orders)) {
        // process(orders.map((x: any) => x.messageJson));
        const socketRows = orders?.map((item: any) => item?.messageJson);
        const locates = socketRows?.filter((order: any) =>
         order?.username !== loginUser && order?.assetType === 'Locate' && (!isAdmin? order.cpty === activeClientShortName: true)
        );
          if (locates.length > 0) {
            process(locates);
          }
      }

      const newRows = Array.from(map.values());

     const uniqRows = _.uniqBy([...newRows], 'locate_id')
      rowDataRef.current = [...uniqRows];

      const sortedRows: any[] = _.orderBy(
                uniqRows,
                "updatetime",
                "desc"
              );
      rowDataRef.current = sortedRows;
      gridRef?.current?.api?.setRowData(sortedRows);

        setLocateBkpStr(JSON.stringify([...sortedRows]))

        gridRef?.current?.api?.refreshCells({
          force: true,
          suppressFlash: true,
          columns:['comments']
      });

        return sortedRows;
      });
    }

    
  };

  useEffect(() => {
    setGridTheme(
      theme.palette.mode === "dark"
        ? " ag-theme-balham-dark"
        : " ag-theme-balham"
    );
  }, [theme.palette.mode]);

  useEffect(() => {
    // setLocateRows([]);
    setInitialLocates([]);
    if (date && !_.isUndefined(date)) {
      // setLocateRows([]);
      setInitialLocates([]);
      setLocateBkpStr("");
      setShowScreenLoader(true);
      getLocates();

      gridRef?.current?.api?.refreshCells({
        force: true,
        suppressFlash: true,
      });
      gridRef?.current?.api?.deselectAll();
    }
  }, [isLocatesRefreshed, date]);

  let gridApi: any;
  const defaultColDef = useMemo<any>(() => {
    return {
      flex: 1,
      sortable: true,
      filter: true,
      floatingFilter: false,
      suppressFilterButton: false,
      editable: false,

      resizable: true,
      headerCheckboxSelectionFilteredOnly: true,
      menuTabs: [constants.FilterMenuTab],
      tooltipShowDelay: 10,
      tooltipMouseTrack: true,
      suppressKeyboardEvent: (params: any) => {
        const isTabKey = params?.event?.key === constants.Tab;
        if (isTabKey) gridRef?.current?.api?.stopEditing();

        return false;
      },
    };
  }, []);

  useEffect(() => {
    if (defaultFilter && gridRef) {
      const filterComponent = gridRef?.current?.api?.getFilterInstance(
        defaultFilter.column
      );
      if (filterComponent) {
        filterComponent?.setModel({ values: defaultFilter.values });
        gridApi.onFilterChanged();
      }
    }
  }, [gridRef]);

  // useEffect(() => {
  //   onGridRowDataChanged();
  // }, [locateRows]);

  const getLocates = async () => {
    try {
      onRowSelect(null);
      setCurrentRowId(null);
      const accountId = window.localStorage.getItem("activeAccountCode");
      const activeClientShortName = window.localStorage.getItem(
        "activeClientShortName"
      );

      const request = isAdmin
        ? {
            date: moment(date).format("yyyy-MM-DD"),
            sec_id: null,
            isInquiry: false,
            account: accountId,
          }
        : {
            date: moment(date).format("yyyy-MM-DD"),
            sec_id: null,
            isInquiry: false,
            account: accountId,
            clientShortCode: activeClientShortName,
          };

      const token = window.localStorage.getItem("refreshtoken");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.getLocateLists}`,
          JSON.stringify(request),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
            const rows = await response?.data;
            if (rows && _.isArray(rows) && rows?.length > 0) {
              //  const refRows = rows as never;
              const dataRows = rows?.map((row: any) => {
                return {
                  ...row,
                  locate_id: row?.locate_id,
                  centpershare: _.isNaN(row?.centpershare)
                    ? ""
                    : row?.centpershare?.toFixed(4),
                  centpershare_appr: _.isNaN(row?.centpershare_appr)
                    ? ""
                    : row?.centpershare_appr?.toFixed(4),
                  rebate: !_.isNaN(row?.rebate)
                    ? (+row?.rebate)?.toFixed(4)
                    : "",
                  rate_appr: !_.isNaN(row?.rate_appr)
                    ? (+row?.rate_appr)?.toFixed(4)
                    : "",
                  fee: !_.isNaN(row?.fee) ? "" : +row?.fee,
                  updatetime: moment(row.updatetime)?.format("HH:mm:ss"),
                };
              });
              const sortedRows: any[] = _.orderBy(
                dataRows,
                "updatetime",
                "desc"
              );
              rowDataRef.current = sortedRows;
              gridRef?.current?.api?.setRowData(sortedRows);

              setInitialLocates([...sortedRows]);
              setLocateBkpStr(JSON.stringify([...sortedRows]));

              if (
                sortedRows &&
                _.isArray(sortedRows) &&
                !_.isEmpty(sortedRows)
              ) {
                if (isValidDate()) {
                  onRowSelect(sortedRows[0]);
                  setCurrentRowId(sortedRows[0]?.locate_id);
                }
              }
            } else {
              // setLocateRows([]);
              setInitialLocates([]);
              setLocateBkpStr("");
            }
          } else if (response?.status === 401) {
            //logout(channel)
          } else {
            // setLocateRows([]);
            setInitialLocates([]);
            setLocateBkpStr("");
          }
        });
    } catch (err) {
      console.log(err);
      // setLocateRows([]);
      setInitialLocates([]);
      setLocateBkpStr("");
      setShowScreenLoader(false);
    } finally {
      setShowScreenLoader(false);
    }
  };

  const isValidDate = () => {
    return validateTermDate(date);
  };

  const onGridReady = (params: any) => {
    params.api.sizeColumnsToFit();
    gridApi = params.api;
    const gridColumnApi = params.columnApi;
    getName(gridApi, gridColumnApi);

    // Emmits the gridApi refrence to the parent component
    if (getGridApi) {
      getGridApi(gridApi, gridColumnApi);
    }
    getBtnRef(gridRef);
  };

  const getName = (api: any, columnApi: any) => {
    if (!api || !columnApi) return;
    if (showTotalRow) {
      const rows: any = {};
      const result: any[] = [];

      columnApi?.getAllGridColumns().forEach((item: any) => {
        rows[item.colId] = null;
      });

      const columnsWithAggregation = [
        "request_quantity",
        "approved_quantity",
        "response_quantity",
        "filled_quantity",
        "centpershare",
        "centpershare_appr",
        "fee",
        "rebate",
        "rate_appr",
        "locate_pnl",
        'pnl'
      ];

      const columnsWithAvg = [
        "centpershare",
        "centpershare_appr",
        "fee",
        "rebate",
        "rate_appr",
      ];

      columnsWithAggregation.forEach((element) => {
        api?.forEachNodeAfterFilter((rowNode: any) => {
          if (rowNode.data[element]) {
            rows[element] += Number(parseFloat(rowNode.data[element]));
          }
        });
      });

      columnsWithAvg.forEach((element) => {
        const nodeCount = api.getDisplayedRowCount();
        const avg = (rows[element] / nodeCount).toString();
        if (nodeCount !== 0 && !_.isNaN(avg)) {
          rows[element] =
            element === "rate"
              ? Number(parseFloat(avg)?.toFixed(3))
              : Number(parseFloat(avg)?.toFixed(4));
        }
      });

      const countUnique = (attribute: string): number => {
        const uniqueItemsSet: Set<any> = new Set();
        api?.forEachNodeAfterFilter((rowNode: any) => {
          if (rowNode?.data instanceof Object && attribute in rowNode.data) {
            uniqueItemsSet.add(rowNode.data[attribute]);
          }
        });
        return uniqueItemsSet.size;
      };

     

      const labelRow = {
        ticker: "Symbol",
        locate_id: "Rows",
        request_quantity: "Req Qty",
        approved_quantity: "Appr Qty",
        response_quantity: "Res Qty",
        filled_quantity: "Used Qty",
        cpty: "Clients",
        username: "Users",
        centpershare: "Avg Req CPS",
        centpershare_appr: "Avg Appr CPS",
        fee: "Avg Fee",
        rebate: "Avg Req Rebate",
        rate_appr: "Avg Appr Rebate",
        locate_pnl: isAdmin? "PNL":'Total Cost',
        pnl:'Total Cost',
        isTotalRow: true,
        isTotalLabel: true,
      };

      rows["isTotalRow"] = true;
      rows["locate_id"] = api.getDisplayedRowCount();
      rows["ticker"] = countUnique("ticker");
      rows["cpty"] = countUnique("cpty");
      rows["username"] = countUnique("username");

      result.push(labelRow);
      result.push(rows);
      api?.setPinnedBottomRowData(result);
    } else {
      api?.setPinnedBottomRowData([]);
    }
  };

  /**
   * Method counts the unique value for given attribute (for filtered values also)
   * @param attribute
   * @returns unique values count
   */
  // const countUnique = (attribute: string, api: GridApi): any => {
  //   const uniqueItemsSet: Set<any> = new Set();
  //   api?.forEachNodeAfterFilter((rowNode: any) => {
  //     if (rowNode?.data instanceof Object && attribute in rowNode.data) {
  //       uniqueItemsSet.add(rowNode.data[attribute]);
  //     }
  //   });

  //   return convertToCommas(uniqueItemsSet.size);
  // };

  useEffect(() => {
    if (isDeselectAll !== undefined) gridRef.current?.api?.deselectAll();
  }, [isDeselectAll]);

  const rowClassRules = useMemo(() => {
    return {
      "is-new-warning": (params: any) => {
        const isNew = params.data.is_new;

        return isNew === "TRUE";
      },
      "is-new-recall": (params: any) => {
        const isNew = params.data.is_Recall;

        return isNew === "True";
      },
    };
  }, []);

  const autoGroupColumnDef = useMemo(() => {
    return {
      minWidth: 100,
      maxWidth: 200,
    };
  }, []);

  const getRowId = (params: any) => {
    if (params && params.data) {
      if (params.data.locate_id) {
        return params.data.locate_id;
      } else if (params.data.id) {
        return params.data.id;
      }
    }

    return makeid(5);
  };

  function makeid(length: any) {
    let result = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }

    return result;
  }

  const sideBar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: "columns",
          labelDefault: "Columns",
          labelKey: "columns",
          iconKey: "columns",
          toolPanel: "agColumnsToolPanel",
          toolPanelParams: {
            suppressRowGroups: true,
            suppressValues: true,
            suppressPivots: true,
            suppressPivotMode: true,
            suppressColumnFilter: false,
            suppressColumnSelectAll: false,
            suppressColumnExpandAll: true,
          },
        },
      ],
      defaultToolPanel: "",
    };
  }, []);

  const onGridRowDataChanged = () => {
    const refreshParams: any = {
      force: true,
      suppressFlash: true,
      columns: ["select"],
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
    var gridColumnApi = gridRef.current!.columnApi;
    getName(gridApi, gridColumnApi);
  };

  const onDoesfilter = useCallback((node: any) => {
    doesExternalFilterPass(node);

    return true;
  }, []);

  const updateLocateApproved = async (request: any) => {
    try {
      const token = window.localStorage.getItem("refreshtoken");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      await axios
        .post(
          `${serviceAPIMapping["LOCATEMANAGEMENT-SERVICE"].apiRouteURL}${EndPoint.updateLocateApproved}`,
          JSON.stringify([request]),
          {
            headers: headers,
          }
        )
        .then(async (response: any) => {
          if (response?.status === 200) {
          } else if (response?.status === 401) {
            //logout(channel)
          }
        });
    } catch (err) {
      console.log(err);
    } finally {
      setShowScreenLoader(false);
      gridApi?.refreshCells();
    }
  };

  const isRowSelectable = useCallback((params: any) => {
    return true;
    // return (params?.data?.status === LocateStatus.New || ((params?.data?.isApprovedQuantityChanged ||
    //   params?.data?.isCentPerShareChanged ||
    //   params?.data?.isFeeChanged ||
    //   params?.data?.isRebateChanged ||
    //   params?.data?.isCommentsChanged) && params?.data?.status !== LocateStatus.New && !params?.data?.hasError));
  }, []);

  const onCellValueChanged = useCallback(
    (event: any) => {
      setInitialLocates((previousData: any) => {
        const initLocates = previousData
          // previousData?.length > 0 ? JSON.parse(previousData) : [];
        updateLocateCells(event, initLocates);

        return previousData;
      });
    },
    [isRowSelectable]
  );

  const updateLocateCells = (event: any, initLocates: any[]) => {
    const row = event.data;
    const changedValue = event?.value;
    const column = event.column;

    const index = initLocates?.findIndex(
      (x: any) => x?.locate_id === row?.locate_id
    );
    row.isApprovedQuantityValid =
      validateQuantity(row?.approved_quantity) &&
      row?.request_quantity >= row?.approved_quantity;
    row.isCentsPerShareValid =
      !_.isNaN(row.centpershare_appr) && +row.centpershare_appr >= 0;
    row.isRebateValid =
      !_.isNaN(row.rebate) && +row.rebate !== 0 && validateRate(row.rebate);
      
    row.isReqQuantityValid =
      validateQuantity(row?.request_quantity) &&
      row?.request_quantity >= row?.approved_quantity;
    try {
      if (index >= 0) {
        row.originalStatus = initLocates[index]?.status;
        switch (column.getColId()) {
          case "request_quantity":
            if (isString(changedValue) && changedValue?.includes(",")) {
              row.request_quantity = changedValue?.replace(/,/g, "");
            } else {
              row.request_quantity = isNaN(changedValue) ? 0 : changedValue;
            }

            row.isReqQuantityChanged = true
              // initLocates[index]?.request_quantity !== changedValue;
            // row.isReqQuantityValid = validateQuantity(row?.request_quantity);
            row.isApprovedQuantityValid =
              row?.request_quantity >= row?.approved_quantity;

            row.isReqQuantityValid = validateQuantity(row?.request_quantity) && row?.request_quantity >= row?.approved_quantity;

            break;
          case "approved_quantity":
            if (
              _.isString(row.approved_quantity) &&
              _.includes(row.approved_quantity, ",")
            ) {
              row.approved_quantity = row.approved_quantity?.replace(/,/g, "");
            } else {
              row.approved_quantity = isNaN(changedValue) ? 0 : changedValue;
            }
            row.isApprovedQuantityChanged = true
              // initLocates[index]?.approved_quantity !== changedValue;
            row.isApprovedQuantityValid =
              validateQuantity(row?.approved_quantity) &&
              row?.request_quantity >= row?.approved_quantity;
            row.isReqQuantityValid = validateQuantity(row?.request_quantity) && row?.request_quantity >= row?.approved_quantity;
            
            break;
          case "centpershare_appr":
            row.centpershare_appr = _.isNaN(changedValue)
              ? null
              : Math.abs(changedValue);
            row.isCentsPerShareValid =
              !_.isNaN(changedValue) && +changedValue >= 0;
            row.isCentPerShareChanged = true
              // initLocates[index]?.centpershare_appr !== changedValue;
            break;
          case "fee":
            row.fee = changedValue;
            row.isFeeChanged = true
            //initLocates[index]?.fee !== changedValue;
            break;
          case "rate_appr":
            row.rate_appr = +changedValue;
            row.isRebateChanged = true
              // initLocates[index]?.rate_appr !== changedValue;
            row.isRebateValid =
              !_.isNaN(changedValue) && validateRate(changedValue);
            break;
          case "comments":
            row.comments = changedValue;
            row.isCommentsChanged = true;
            break;
        }
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      // setLocateRows((previousRows: any) => {
      // const gridRows = previousRows;
      const gridRows = [...rowDataRef?.current];
      const isCents = row?.isCentPerShareChanged
        ? row.isCentsPerShareValid
        : true;

      row.errorCode = "";
      const isRebate = row?.isRebateChanged ? row.isRebateValid : true;
      if (!row?.isApprovedQuantityValid) {
        row.errorCode = "Invalid Appr Quantity";
      } else if (row?.isCentPerShareChanged && !isCents) {
        row.errorCode = "Invalid CPS";
      } else if (row?.isRebateChanged && !isRebate) {
        row.errorCode = "Invalid Rate";
      }

      row.hasError = !(
        isCents &&
        isRebate &&
        row?.isApprovedQuantityValid &&
        row?.isReqQuantityValid
      );

      row.isRowChanged =
        row?.isApprovedQuantityChanged ||
        row?.isCentPerShareChanged ||
        row?.isFeeChanged ||
        row?.isRebateChanged ||
        row?.isReqQuantityChanged ||
        row?.isCommentsChanged;

      // row.status = (initLocates[index].status === LocateStatus.New || initLocates[index].status === LocateStatus.Error || initLocates[index].status === LocateStatus.Rejected)?(row.hasError ?LocateStatus.Error:LocateStatus.New): initLocates[index].status
      if(index>=0 && initLocates[index]){
        row.status =
        initLocates[index].status === LocateStatus.New ||
        initLocates[index].status === LocateStatus.Error
          ? row.hasError
            ? LocateStatus.Error
            : initLocates[index].status === LocateStatus.Error
            ? LocateStatus.New
            : initLocates[index].status
          : initLocates[index].status;
      }
      
      if (row.status === LocateStatus.Error && !row.isReqQuantityValid) {
        row.error_status = "Invalid Req Quantity";
      } else if (
        row.status === LocateStatus.Error &&
        !row.isApprovedQuantityValid
      ) {
        row.error_status = "Invalid Appr Quantity";
      } else {
        row.error_status = "";
      }

      const rowIndex = gridRows?.findIndex(
        (x: any) => x?.locate_id === row?.locate_id
      );
      if (rowIndex >= 0) {
        [...rowDataRef.current][rowIndex] = row;

        let updateArray: any = [];
        updateArray.push(row);
        gridApi = gridRef?.current!.api;
        gridApi?.applyTransaction({ update: updateArray });
        var params = {
          force: true,
          suppressFlash: true,
          columns: [event.column],
        };

        gridApi?.refreshCells(params);
      }

      // return [...gridRows];
      // });

      setSelectedRows((previousRows: any) => {
        const currentRows = [...previousRows];
        const rowIndex = currentRows?.findIndex(
          (x: any) => x?.locate_id === row?.locate_id
        );
        if (rowIndex >= 0) {
          currentRows[rowIndex] = row;
        }

        return [...currentRows];
      });
    }
  };

  const onSelectionChanged = (params: any) => {
    const selectedRows = params?.api?.getSelectedRows();
    if (selectedRows) {
      setSelectedRows(selectedRows);
    }
  };

  const onFirstDataRendered = () => {
    let gridColumnApi = gridRef?.current!.columnApi;
    let gridRefApi = gridRef?.current!.api;
    getName(gridRefApi, gridColumnApi);
  };

  const onFilterChanged = (params: FilterChangedEvent) => {
    const { api, columnApi } = params;
    getName(api, columnApi);
  };

  useEffect(() => {
    gridApi = gridRef.current!.api;
    var gridColumnApi = gridRef.current!.columnApi;
    getName(gridApi, gridColumnApi);
    const refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.refreshCells(refreshParams);
  }, [showTotalRow]);

  const onRowClicked = (params: any) => {
    if (params?.data?.ticker) {
      onRowSelect(params?.data);
      setCurrentRowId(params?.data?.locate_id);
    }
  };

  const getRowStyle: any = (params: any) => {
    if (
      params.data.locate_id === currentRowId &&
      params.node.rowPinned !== "bottom"
    ) {
      params.node.suppressRowHoverHighlight = true;
      return { background: "#bbdffc" };
    } else if (
      params.node.rowIndex % 2 === 0 &&
      params.node.rowPinned !== "bottom"
    ) {
      return { background: "#F8F8F8" };
    }
    if (params.node.rowPinned === "bottom") {
      return {
        backgroundColor: "#fff !importnat",
        color: "#164691",
        fontWeight: "700",
        fontSize: "0.75rem",
        fontStyle: "normal",
        borderBottom: "none",
        border: "none",
      };
    } else {
      return { backgroundColor: "#fff" };
    }
  };

  useEffect(() => {
    const rows = _.uniqBy([...rowDataRef.current], "locate_id") as any[];
    if (!rows?.length) return;

    setLocateBkpStr(JSON.stringify(rows));
    const statusArray = [
      statusFilter?.isNewFilterActive && "new",
      statusFilter?.isApprovedFilterActive && "approved",
      statusFilter?.isTopupFilterActive && "top-up",
      statusFilter?.isRejectedFilterActive && "rejected",
      statusFilter?.isPartialFilterActive && "partial",
      statusFilter?.isPendingFilterActive && "pending",
    ].filter(Boolean);

    const sourceArray = [
      sourceFilter?.isUIFilterActive && "UI",
      sourceFilter?.isFileFilterActive && "FILE",
      sourceFilter?.isFixFilterActive && "FIX",
    ].filter(Boolean);

    const allSourceArray = ["ui", "file", "fix"];
    const allStatusArray = [
      "new",
      "approved",
      "top-up",
      "rejected",
      "partial",
      "pending",
      "error",
    ];
    const setFilter = (
      field: string,
      values: string[] | undefined,
      isSourceFilter: boolean,
      isStatusFilter: boolean
    ) => {
      const filter = gridRef?.current?.api?.getFilterInstance(field);
      if (!filter) return;

      const allValues = isSourceFilter
        ? allSourceArray
        : isStatusFilter
        ? allStatusArray
        : filter?.valueModel?.availableKeys ?? [];
      const newValues = values?.length ? values : [...allValues];

      // if (newValues?.length) {
      //   filter.setModel({ values: newValues });
      //   gridRef?.current?.api?.onFilterChanged();
      // }
        if (newValues?.length) {
        if ('getChildFilterInstance' in filter) {
       
        const setFilter = filter.getChildFilterInstance(1);
        if (setFilter) {
          setFilter.setModel({ values: newValues });
        }
        } else {
         
         filter.setModel({ values: newValues });
        }

      gridRef?.current?.api?.onFilterChanged();
    }
    };

    // if (isAdmin) {
      setFilter("locate_src", sourceArray, true, false);
      setFilter("status", statusArray, false, true);
    // }

    if (globalClient) {
      const filter = gridRef?.current?.api?.getFilterInstance("cpty");
      if (filter) {
        const allValues =
          clientList?.length > 0 ? filter?.valueModel?.availableKeys ?? [] : [];
        const values = globalClient === "all" ? [...allValues] : [globalClient];

        if (values.length) {
          filter.setModel({ values });
          gridRef?.current?.api?.onFilterChanged();
        }
      }
    }

    if (globalClient && rows.length > 0) {
      setCurrentRowId(rows[0]?.locate_id);
    }

    setSelectedRows((previousRows: any[]) => {
      if (!previousRows?.length) return previousRows;

      const rowMap = new Map(rows.map((r) => [r.locate_id, r]));
      return previousRows.map((r) => rowMap.get(r.locate_id) || r);
    });
  }, [sourceFilter, statusFilter, initialLocates, globalClient]);

  useEffect(() => {
    if (
      insertLocateRows &&
      _.isArray(insertLocateRows) &&
      !_.isEmpty(insertLocateRows)
    ) {

      setInitialLocates((previousRows: any) => {
        const currentRows = [...insertLocateRows, ...previousRows];
        const uniqRows = _.uniqBy(currentRows, "locate_id");

        setLocateBkpStr(JSON.stringify([...uniqRows]));

        return uniqRows;
      });

      
    }
  }, [insertLocateRows]);

  useEffect(() => {
    const refreshParams: any = {
      force: true,
      suppressFlash: true,
    };
    gridRef?.current!.api?.redrawRows(refreshParams);
  }, [currentRowId]);

  useEffect(() => {
    gridRef?.current?.api?.setFilterModel(null);
  }, [isResetFilters]);

  useEffect(() => {
    if (newRows && _.isArray(newRows) && newRows?.length > 0) {

      setInitialLocates((previousRows: any)=>{
        const currentMap = new Map(previousRows.map((row: any) => [row.locate_id, row]));
        const insertedRows: any[] = [];
        const updatedRows: any[] = [];
        const processRows = (rows: any[], isUpdate = false) => {
          rows.forEach((row: any) => {
            row.updatetime = moment(row?.updatetime)?.format("HH:mm:ss");
            if (currentMap.has(row.locate_id)) {
              currentMap.set(row.locate_id, row);
              updatedRows.push(row);
            } else if (!isUpdate && !currentMap.has(row.locate_id)) {
              currentMap.set(row.locate_id, row);
              insertedRows.push(row);
            }
          });
        };

        if (_.isArray(newRows) && newRows.length > 0) {
          const socketRows = newRows.map((item: any) => item);
          if (socketRows.length > 0) {
            processRows(socketRows);
          }
        }

        const newRowData = Array.from(currentMap.values());
        
         const uniqRows = _.uniqBy([...newRowData], 'locate_id')
         const sortedRows: any[] = _.orderBy(
                uniqRows,
                "updatetime",
                "desc"
              );
        rowDataRef.current = sortedRows;
        gridRef?.current?.api?.setRowData(sortedRows);
        setLocateBkpStr(JSON.stringify([...sortedRows]))

          return sortedRows
        })

      
    }
  }, [newRows]);

  useEffect(() => {
    setCurrentSelectedTicker(currentKPITicker);
  }, [currentKPITicker]);

  return (
    <div
      className={"h-100" + gridTheme}
      style={{
        width: "100%",
      }}
    >
      {showScreenLoader && <SpinnerFullScreen></SpinnerFullScreen>}
      {title !== undefined && (
        <div className="drag-handle title-subHeaderTitle"> {title} </div>
      )}

      <AgGridReact
        ref={gridRef}
        defaultColDef={defaultColDef}
        headerHeight={26}
        rowHeight={26}
        columnDefs={columnDefs}
        // getRowId={getRowId}
        onRowDataUpdated={onGridRowDataChanged}
        getRowId={(params: any) => params.data.locate_id}
        suppressAnimationFrame={true}
        domLayout="normal"
        // rowData={locateRows}
        suppressAggFuncInHeader={true}
        enableRangeSelection={true}
        onGridReady={onGridReady}
        rowClassRules={rowClassRules}
        autoGroupColumnDef={autoGroupColumnDef}
        groupSelectsChildren={true}
        groupSelectsFiltered={true}
        sideBar={sideBar}
        animateRows={false}
        pivotMode={false}
        cacheQuickFilter={true}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={onDoesfilter}
        getContextMenuItems={getContextMenuItems}
        quickFilterText={globalSearch}
        overlayLoadingTemplate={
          '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
        }
        onCellValueChanged={onCellValueChanged}
        rowSelection={"multiple"}
        onSelectionChanged={onSelectionChanged}
        isRowSelectable={isRowSelectable}
        onFirstDataRendered={onFirstDataRendered}
        onFilterChanged={onFilterChanged}
        getRowStyle={getRowStyle}
        onRowClicked={onRowClicked}
        suppressRowClickSelection={true}
        suppressRowHoverHighlight={true}
        // enableCellChangeFlash={true}
      ></AgGridReact>
    </div>
  );
};

export default LocatesGrid;
